<template>
  <div class="nav-wrapper">
    <transition name="fade">
      <div class="backdrop" v-if="openContact">
        <div class="modal">
          <h3 class="section-heading form-heading">Let us Work Together</h3>
          <i
            class="fa-regular fa-circle-xmark rotate-in-center"
            @click="closeForm"
          ></i>
          <form @submit="handleSubmit" name="portfolioForm" method="POST" netlify data-netlify-honeypot="bot-field" data-netlify="true" class="contact-form">
          <input type="hidden" name="form-name" value="portfolioForm">
            <div class="row">
              <div class="form-item col-6">
                <div class="form-group">
                  <input type="text" v-model="form.name" id="name" class="form-control" placeholder="Name " required name="name"/>
                </div>
              </div>
              <div class="form-item col-6">
                <div class="form-group">
                  <input type="email" id="email" v-model="form.email" class="form-control" placeholder="Email " required name="email"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-item col-12">
                <div class="form-group">
                  <input type="text" id="subject" v-model="form.subject" class="form-control" placeholder="Subject " required name="subject"/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-item col-12">
                <div class="form-group">
                  <textarea id="message" class="form-control" v-model="form.message" placeholder="Message " required name="message"></textarea>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-item col-12">
                <button type="submit" value="Send Message" class="btn-primary form-btn">
                  Send Message
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </transition>
    <div class="container">
      <nav class="nav-container">
        <div class="logo">
          <router-link to="/" tag="a">Shahab Malik</router-link>
        </div>

        <div class="nav-links">
          <ul>
            <li><router-link to="/about" tag="a">About</router-link></li>
            <li><router-link to="/#services" tag="a">Services</router-link></li>
            <li><router-link to="/projects" tag="a">Projects</router-link></li>
            <li>
              <a href="https://medium.com/@shahabmalik227710" target="_blank"
                >Blog</a
              >
            </li>
            <li><a @click="openForm">Contact</a></li>
          </ul>
        </div>
        <i
          :class="
            open
              ? 'fa-regular fa-circle-xmark rotate-in-center'
              : 'fa-solid fa-bars icon-in'
          "
          @click="toggleOpen"
        ></i>
      </nav>
      <transition name="fade">
        <div :class="open ? 'mobile-nav open' : 'mobile-nav fade-out'">
          <ul>
            <li>
              <router-link to="/about" tag="a" @click.native="closeNav"
                >About</router-link
              >
            </li>
            <li>
              <router-link to="/#services" tag="a" @click.native="closeNav"
                >Services</router-link
              >
            </li>
            <li>
              <router-link to="/projects" tag="a" @click.native="closeNav"
                >Projects</router-link
              >
            </li>
            <li>
              <a href="https://medium.com/@shahabmalik227710" target="_blank"
                >Blog</a
              >
            </li>
            <li><a @click="openForm">Contact</a></li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    computed: {
      ...mapGetters(["openContact"]),
    },
    data() {
      return {
        open: false,
        form:{
name:'',
email:'',
subject:'',
message:''
        }
      };
    },
    methods: {
      toggleOpen() {
        this.open = !this.open;
      },
      openForm() {
        if (this.open) {
          this.open = false;
        }
        this.$store.dispatch("openContact");
      },
      closeForm() {
        this.$store.dispatch("closeContact");
      },
      closeNav() {
        if (this.open) {
          this.open = false;
        }
      },
      encode(data) {
      return Object.keys(data)
        .map(
          (key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`,
        )
        .join('&');
    },
    handleSubmit(){
      fetch('/',{
        method:'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body:this.encode({
          'form-name':'portfolioForm',
          ...this.form
        })
      }).then(()=>console.log('Submitted')).catch(e=>console.error(e))
    }
    },
  };
</script>

<style scoped>
  .nav-wrapper {
    background: #f5f5f5;
    position: relative;
  }
  .nav-container {
    font-family: "Combo", cursive;
    padding: 30px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .logo a {
    text-decoration: none;
    font-size: 2em;
    font-weight: 700;
    color: var(--color-primary);
    border-bottom: 2px solid transparent;
  }
  .logo a:hover {
    border-bottom: 2px solid var(--color-green);
  }
  .nav-links ul {
    display: flex;
    gap: 40px;
  }
  .nav-links ul li {
    list-style: none;
  }
  .nav-links ul li a {
    font-family: "Raleway", sans-serif;
    text-decoration: none;
    color: var(--color-primary);
    font-size: 1.2em;
    border-bottom: 2px solid transparent;
    font-weight: 500;
    cursor: pointer;
  }

  .nav-links ul li a:hover,
  .nav-links ul li a.router-link-exact-active {
    color: var(--color-tertiary);
    border-bottom: 2px solid var(--color-green);
  }
  nav i {
    display: none;
  }
  .mobile-nav {
    display: none;
  }

  /* ----------------------------------------------
 * Generated by Animista on 2022-9-8 15:10:29
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

  /**
 * ----------------------------------------
 * animation slide-right
 * ----------------------------------------
 */
  @-webkit-keyframes slide-right {
    0% {
      -webkit-transform: translateX(-1000px);
      transform: translateX(-1000px);
    }
    100% {
      -webkit-transform: translateX(0px);
      transform: translateX(0px);
    }
  }
  @keyframes slide-right {
    0% {
      -webkit-transform: translateX(-1000px);
      transform: translateX(-1000px);
    }
    100% {
      -webkit-transform: translateX(0px);
      transform: translateX(0px);
    }
  }

  @-webkit-keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @-webkit-keyframes rotate-in-center {
    0% {
      -webkit-transform: rotate(-360deg);
      transform: rotate(-360deg);
      opacity: 0;
    }
    100% {
      -webkit-transform: rotate(0);
      transform: rotate(0);
      opacity: 1;
    }
  }
  @keyframes rotate-in-center {
    0% {
      -webkit-transform: rotate(-360deg);
      transform: rotate(-360deg);
      opacity: 0;
    }
    100% {
      -webkit-transform: rotate(0);
      transform: rotate(0);
      opacity: 1;
    }
  }

  @-webkit-keyframes fade-out {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  @keyframes fade-out {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  .backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 20;
    background-color: rgba(0, 0, 0, 0.75);
  }

  .modal {
    position: fixed;
    top: 10vh;
    left: 20%;
    width: 60%;
    background-color: white;
    padding: 20px;
    border-radius: 14px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
    z-index: 30;
    animation: slide-down 300ms ease-out forwards;
    display: flex;
    flex-direction: column;
  }

  @keyframes slide-down {
    from {
      opacity: 0;
      transform: translateY(-3rem);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .modal i {
    position: absolute;
    right: 20px;
    font-size: 2em;
    top: 30px;
    margin-bottom: 30px;
    cursor: pointer;
  }
  /* Contact Form */
  .form-heading {
    margin-bottom: 20px !important;
    font-size: 2em;
    margin-top: 20px;
  }
  .row {
    display: flex;
    justify-content: space-between;
  }
  .modal .contact-form {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 10px 40px;
  }

  .modal .contact-form .col-6 {
    flex: 0 0 48%;
    max-width: 50%;
  }

  .modal .contact-form .col-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .modal .contact-form .form-item {
    margin-bottom: 30px;
  }

  .modal .contact-form .form-item .form-control {
    width: 100%;
    height: 50px;
    border-radius: 15px;
    -webkit-border-radius: 15px;
    -moz-border-radius: 15px;
    -ms-border-radius: 15px;
    -o-border-radius: 15px;
    background: #f5f5f5;
    border: 1px solid rgba(128, 128, 128, 0.1);
    padding: 10px 25px;
    font-size: 16px;
    color: var(--color-secondary);
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
  }

  .modal .contact-form .form-item .form-control:focus {
    box-shadow: 0 0 20px rgba(48, 46, 77, 0.15);
    outline: none;
  }

  .modal .contact-form .form-item textarea.form-control {
    height: 120px;
  }

  .modal .contact-form .btn {
    padding: 10px 20px;
    margin: 0 auto;
  }
  .form-btn {
    padding: 15px 30px;
    font-size: 1em;
    margin-top: 10px;
  }
  .puff-out-center {
    -webkit-animation: puff-out-center 1s cubic-bezier(0.165, 0.84, 0.44, 1)
      both;
    animation: puff-out-center 1s cubic-bezier(0.165, 0.84, 0.44, 1) both;
  }

  @-webkit-keyframes puff-out-center {
    0% {
      -webkit-transform: scale(1);
      transform: scale(1);
      -webkit-filter: blur(0px);
      filter: blur(0px);
      opacity: 1;
    }
    100% {
      -webkit-transform: scale(2);
      transform: scale(2);
      -webkit-filter: blur(4px);
      filter: blur(4px);
      opacity: 0;
    }
  }
  @keyframes puff-out-center {
    0% {
      -webkit-transform: scale(1);
      transform: scale(1);
      -webkit-filter: blur(0px);
      filter: blur(0px);
      opacity: 1;
    }
    100% {
      -webkit-transform: scale(2);
      transform: scale(2);
      -webkit-filter: blur(4px);
      filter: blur(4px);
      opacity: 0;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }

  @media only screen and (max-width: 767px) {
    .modal .contact-form {
      padding: 10px 20px;
    }
    .nav-container {
      padding: 20px 0px !important;
    }
    .logo a {
      font-size: 1.5em;
    }
    .nav-links ul {
      gap: 20px;
    }
    .nav-links ul li a {
      font-family: "Raleway", sans-serif;
      text-decoration: none;
      color: var(--color-primary);
      font-size: 1.1em;
      border-bottom: 2px solid transparent;
      font-weight: 500;
    }
    .row {
      flex-direction: column;
    }
    .modal .contact-form .col-6 {
      flex: 0 0 100%;
      max-width: 100%;
    }
    .modal {
      position: fixed;
      top: 5vh;
      left: 10%;
      width: 80%;
      background-color: white;
      padding: 15px;
      border-radius: 14px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
      z-index: 30;
      animation: slide-down 300ms ease-out forwards;
    }
    .form-heading {
      margin-bottom: 20px !important;
      font-size: 1.5em;
      margin-top: 15px;
    }
    .form-btn {
      padding: 15px 30px;
      font-size: 1em;
      margin-top: 10px;
      margin-bottom: 0 !important;
    }
    .backdrop {
      margin-bottom: 40px;
    }
  }

  @media only screen and (max-width: 480px) {
    .nav-links ul {
      display: none;
    }
    nav i {
      display: block;
      font-size: 2em;
      cursor: pointer;
    }
    .icon-in {
      -webkit-animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
      animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
    }
    .rotate-in-center {
      -webkit-animation: rotate-in-center 0.6s
        cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
      animation: rotate-in-center 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    }
    .mobile-nav {
      background: white;
      padding: 40px 40px;
      margin-top: 20px;
      border-radius: 10px;
      display: block;
      position: absolute;
      width: 90%;
      transform: translateX(-1000px);
      box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    }
    .open {
      -webkit-animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
        both;
      animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    }
    .fade-out {
      -webkit-animation: fade-out 1s ease-out both;
      animation: fade-out 1s ease-out both;
    }
    .mobile-nav ul {
      display: flex;
      gap: 30px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .mobile-nav ul li {
      list-style: none;
    }
    .mobile-nav ul li a {
      display: block;
      font-family: "Raleway", sans-serif;
      text-decoration: none;
      font-size: 1.2em;
      font-weight: 700;
      color: var(--color-green);
      padding: 10px 30px;
      border: 1px solid var(--color-green);
      text-align: center;
      width: 150px;
      transition: all 0.5s;
      cursor: pointer;
    }

    .mobile-nav ul li a:hover {
      background-color: var(--color-green);
      color: white;
    }
    .modal {
      position: fixed;
      left: 5%;
      width: 90%;
      padding: 10px;
    }
    .form-heading {
      font-size: 1.3em;
    }
    .modal .contact-form .form-item textarea.form-control {
      height: 100px;
    }
    .modal .contact-form .form-item .form-control {
      width: 100%;
      height: 40px;
      background: #f5f5f5;
      border: 1px solid rgba(128, 128, 128, 0.1);
      padding: 10px 15px;
      font-size: 1em;
      color: var(--color-secondary);
      transition: all 0.3s;
      -webkit-transition: all 0.3s;
      -moz-transition: all 0.3s;
      -ms-transition: all 0.3s;
      -o-transition: all 0.3s;
    }
  }
</style>
